<template>
    <transition name="fade-translate" appear>
        <div class="field-wrapper">
        <div class="container">
            <h2 class="league-create-title">Kreiraj svoju ligu i pozovi prijatelje i članove obitelji.</h2>
            <p class="league-create-p">
                Potrebno je samo da svojoj ligi izabereš ime i - to je to. Dobit ćeš jedinstveni link preko kojeg se svi koje pozoveš mogu priključiti ligi.
            </p>
            <form action="/" class="league-create-title-form" @submit.prevent>
                <label for="leagueName">ime tvoje lige</label>
                <input name="leagueName" type="text" v-model="leagueName">
            </form>
        </div>
        <a href="#" @click.prevent="createUserLiga()" class="button-1 red">
            <span>KREIRAJ LIGU</span>
        </a>
        <ErrorMessageText v-if="error" :message="errorMessage"></ErrorMessageText>
        </div>
    </transition>
</template>

<script>
import ErrorMessageText from './../common/error/ErrorMessageText'

export default {
    name: 'kreirajligufield',
    data: function () {
        return {
            leagueName: '',
            error: false,
            errorMessage: 'Ime tvoje lige je prazno ili neispravno.',
            creatingNewLeague: false
        }
    },
    components: {
        ErrorMessageText
    },
    methods: {
        validateLeaugeName () {
            // if the leauge name is not empty
            if (this.leagueName) {
                // has more then 2 charachters
                if (this.leagueName.length > 0 && this.leagueName.length >= 3) {
                    // Does not start with a number
                    if (isNaN(parseInt(this.leagueName[0]))) {
                        let regex = RegExp('^[a-zA-Z0-9_šđčćžŠĐČĆŽ]*$')
                        /**
                         * Check if the name contains only letters and croatian
                         * chars and number, no emoji or anything else
                         */
                        if (regex.test(this.leagueName.replace(' ', ''))) {
                            return true
                        }
                        if (this.leagueName.length < 22) {
                            return true
                        }
                    }
                }
            }
            return false
        },
        async createUserLiga () {
            if (!this.creatingNewLeague) {
                this.creatingNewLeague = true
                this.error = !this.validateLeaugeName()
                if (!this.error) {
                    let data = await this.$db.lige.createUserLiga({ name: this.leagueName })
                    if (data.success === true) {
                        this.$store.commit('setUserDataVlasnikLige', data.ligaId)
                        this.error = false
                    }
                    data.nazivLige = this.leagueName
                    this.$emit('data', data)
                }
                this.creatingNewLeague = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .container {
        text-align: left;
        margin-bottom: 30px;
    }
    .error-message {
        width: 90%;
        margin: 0 auto;
        padding: 10px;
        margin-top: 10px;
        /deep/ h3 {
            font-weight: 900;
        }
        /deep/ li {
            color: white;
        }
    }
</style>
